module.exports = __webpack_public_path__ + "img/myjbi_modal_img.9c284c9c.png";